import { Injectable } from '../../helpers';
import { Property } from '../../pms-api/models';

export class SubscriptionService extends Injectable {

    static get $inject() {

        return [
            '$rootScope',
        ];
    }

    addonAvailable(addonClass) {

        if (this.$rootScope.$user && this.$rootScope.$user.isAdminRole()) {

            return true;
        }

        const propertyData = JSON.parse(localStorage.getItem('selectedPropertyData'));

        if (propertyData) {

            const property = new Property(propertyData.property);

            return property.hasAddonInSubscription(addonClass);
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/subscription.service.js